import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  TextField,
  DialogActions,
  DialogTitle,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  get_card_data,
  update_card_data,
  get_all_data,
} from "../Api service/APIvariables";
import { validateResponseStatus } from "../hooks/Logout";

const EditDialogModal = ({
  openDialog,
  setOpenDialog,
  fetchData,
  record_id,
  setSelectedEditRow,
}) => {
  const [particularCard, setParticularCard] = useState({
    id: "",
    name: "",
    address: "",
    email: "",
    company_name: "",
    mobile: "",
    position: "",
    website: "",
  });

  const [data, setData] = useState([]);
  const [dataOne, setDataOne] = useState([]);

  const [loading, setLoading] = useState(false);

  const fetchSingleCard = async () => {
    if (!record_id) return;
    try {
      const user_id = localStorage.getItem("user_id");
      const formData = new FormData();
      formData.append("user_id", user_id);
      formData.append("record_id", record_id);
      const token = localStorage.getItem("auth_token");

      const response = await fetch(get_card_data, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Failed to fetch Card Data");
      }

      const result = await response.json();

      if (result?.data) {
        setParticularCard(result.data);
      } else {
        setParticularCard({});
      }
    } catch (error) {
      setLoading(false);
    } finally {
      setSelectedEditRow("");
    }
  };

  useEffect(() => {
    if (record_id) {
      fetchSingleCard();
    }
  }, [record_id]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    setParticularCard((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const updateCard = async () => {
    try {
      const user_id = localStorage.getItem("user_id");
      const formData = new FormData();
      formData.append("user_id", user_id);
      formData.append("record_id", particularCard.id);
      formData.append("name", particularCard.name);
      formData.append("email", particularCard.email);
      formData.append("mobile", particularCard.mobile);
      formData.append("address", particularCard.address);
      formData.append("company_name", particularCard.company_name);
      formData.append("website", particularCard.website);
      formData.append("position", particularCard.position);

      const token = localStorage.getItem("auth_token");

      const response = await fetch(update_card_data, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Failed to update template");
      }

      const result = await response.json();
      console.log(result);

      // if (!result?.error) {
      //   setOpenDialog(false);
      //   fetchData();
      // }
    } catch (error) {
      console.error("Error updating template:", error);
    }
  };

  return (
    <Dialog
      open={openDialog}
      onClose={handleCloseDialog}
      sx={{
        "& .MuiDialog-paper": {
          width: "400px",
          maxWidth: "90%",
          height: "auto",
          borderRadius: "8px",
        },
      }}
    >
      <DialogTitle sx={{ fontWeight: 600 }}>
        {/* {isAddTemplate ? "Add Template" : "Edit Template"}{" "} */}
        Edit Card Details
        <IconButton
          onClick={handleCloseDialog}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <TextField
          label="Name"
          variant="outlined"
          fullWidth
          name="name"
          value={particularCard?.name || ""}
          onChange={handleInputChange}
          sx={{
            marginTop: "10px",
            marginBottom: 1,
            "& .MuiOutlinedInput-root": {
              borderRadius: "4px",
              // backgroundColor: "#f5f5f5",
            },
            "& .MuiInputLabel-root": {
              fontSize: "16px",
              color: "#333",
            },
          }}
        />
        <TextField
          label="Email"
          variant="outlined"
          fullWidth
          name="email"
          value={particularCard?.email || ""}
          onChange={handleInputChange}
          sx={{
            marginTop: "10px",
            marginBottom: 1,
            "& .MuiOutlinedInput-root": {
              borderRadius: "4px",
              // backgroundColor: "#f5f5f5",
            },
            "& .MuiInputLabel-root": {
              fontSize: "16px",
              color: "#333",
            },
          }}
        />
        <TextField
          label="Mobile"
          variant="outlined"
          fullWidth
          name="mobile"
          value={particularCard?.mobile || ""}
          onChange={handleInputChange}
          sx={{
            marginTop: "10px",
            marginBottom: 1,
            "& .MuiOutlinedInput-root": {
              borderRadius: "4px",
              // backgroundColor: "#f5f5f5",
            },
            "& .MuiInputLabel-root": {
              fontSize: "16px",
              color: "#333",
            },
          }}
        />
        <TextField
          label="Address"
          variant="outlined"
          fullWidth
          name="address"
          value={particularCard?.address || ""}
          onChange={handleInputChange}
          sx={{
            marginTop: "10px",
            marginBottom: 1,
            "& .MuiOutlinedInput-root": {
              borderRadius: "4px",
              // backgroundColor: "#f5f5f5",
            },
            "& .MuiInputLabel-root": {
              fontSize: "16px",
              color: "#333",
            },
          }}
        />

        <TextField
          label="Company Name"
          variant="outlined"
          fullWidth
          name="company_name"
          value={particularCard?.company_name || ""}
          onChange={handleInputChange}
          sx={{
            marginTop: "10px",
            marginBottom: 1,
            "& .MuiOutlinedInput-root": {
              borderRadius: "4px",
              // backgroundColor: "#f5f5f5",
            },
            "& .MuiInputLabel-root": {
              fontSize: "16px",
              color: "#333",
            },
          }}
        />
        <TextField
          label="Website"
          variant="outlined"
          fullWidth
          name="website"
          value={particularCard?.website || ""}
          onChange={handleInputChange}
          sx={{
            marginTop: "10px",
            marginBottom: 1,
            "& .MuiOutlinedInput-root": {
              borderRadius: "4px",
              // backgroundColor: "#f5f5f5",
            },
            "& .MuiInputLabel-root": {
              fontSize: "16px",
              color: "#333",
            },
          }}
        />
        <TextField
          label="Position"
          variant="outlined"
          fullWidth
          name="position"
          value={particularCard?.position || ""}
          onChange={handleInputChange}
          sx={{
            marginTop: "10px",
            marginBottom: 1,
            "& .MuiOutlinedInput-root": {
              borderRadius: "4px",
              // backgroundColor: "#f5f5f5",
            },
            "& .MuiInputLabel-root": {
              fontSize: "16px",
              color: "#333",
            },
          }}
        />
      </DialogContent>
      <DialogActions>
        {/* <Button
          onClick={handleCloseDialog}
          color="error"
          sx={{ textTransform: "none" }}
        >
          Cancel
        </Button> */}
        <Button
          onClick={() => {
            updateCard();
            handleCloseDialog();
          }}
          color="success"
          sx={{ textTransform: "none" }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditDialogModal;
